import { render, staticRenderFns } from "./guide-notification-template.vue?vue&type=template&id=cc7b824a&"
import script from "./guide-notification-template.vue?vue&type=script&lang=js&"
export * from "./guide-notification-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports